<template>
  <ElDialog v-model="open" width="900px" class="checkout-dialog" append-to-body>
    <template #header>
      <div class="checkout-dialog__header">
        <div class="checkout-dialog__title">支付方式</div>
      </div>
    </template>

    <div class="payment-options">
      <div :class="[
        'payment-option',
        { 'payment-option--active': method === 'alipay', 'payment-option--disabled': !hasAddr },
      ]" @click="toggleMethod('alipay')">
        <div class="payment-option__radio"></div>
        <i class="iconfont icon-zhifubao"></i>
        <div class="payment-option__main">
          <strong>支付宝支付</strong><span>支持花呗、信用卡</span>
        </div>
      </div>
      <div :class="[
        'payment-option',
        { 'payment-option--active': method === 'wechat', 'payment-option--disabled': !hasAddr },
      ]" @click="toggleMethod('wechat')">
        <div class="payment-option__radio"></div>
        <i class="iconfont icon-weixinzhifu"></i>
        <div class="payment-option__main">
          <strong>微信支付</strong><span>支持钱包、银行卡</span>
        </div>
      </div>
      <div :class="[
        'payment-option',
        { 'payment-option--active': method === 'bank', 'payment-option--disabled': !hasAddr },
      ]" @click="toggleMethod('bank')">
        <div class="payment-option__radio"></div>
        <i class="iconfont icon-yinhangkazhifu"></i>
        <div class="payment-option__main">
          <strong>银行支付</strong><span>支持对公转账</span>
        </div>
      </div>
    </div>

    <div class="address-section" v-if="hasAddr">
      <h3 class="address-section__title">
        <i class="iconfont icon-peisong"></i>
        配送信息
      </h3>
      <div class="address-section__row">
        <div class="address-section__info">
          <span class="address-section__full">{{ curAddr.full }}</span>
          <span class="address-section__meta">{{ curAddr.name }}　{{ curAddr.phone }}</span>
        </div>
        <div class="address-section__actions">
          <i class="iconfont icon-dizhi"></i>
          <a class="address-section__edit" href="javascript:void(0)" @click="showSelect = true">其他收货地址</a>
        </div>
      </div>
    </div>
    <div class="address-section-noaddr" v-else>
      <h3 class="address-section__title">
        <i class="iconfont icon-peisong"></i>
        配送信息
      </h3>
      <ElAlert class="address-section__warn" type="error" title="请先添加收货地址方可继续付款" show-icon />
      <div class="address-section__row">

        <div class="address-section__actions">
          <i class="iconfont icon-dizhi"></i>
          <a class="address-section__add" href="javascript:void(0)" @click="openAdd">添加收货地址</a>
        </div>
      </div>
    </div>

    <div v-if="method !== 'bank'" class="payment-content">
      <div class="payment-content__price">
        ￥ {{ total.toLocaleString() }} <span class="tax">{{ currencyType }}</span>
      </div>
      <div v-if="hasAddr" class="payment-content__qrcode" title="点击刷新二维码" @click="loadPayQRCode">
        <ElImage :src="qr" fit="contain" />
      </div>
      <div v-else class="payment-content__placeholder">
        暂无付款信息<br />请完善您的收货信息
      </div>
      <div class="payment-content__agreements">
        支付即视为你同意《服务协议》《用户许可协议》
      </div>
    </div>

    <div v-else class="bank-transfer">
      <div class="bank-transfer__card">
        <div class="bank-transfer__ok">下单成功</div>
        <div class="bank-transfer__warn">
          请在 {{ countdown || '00:00:00' }} 内完成付款，超时订单商品取消，系统将自动回滚。
        </div>
        <div class="bank-transfer__bill">
          <div class="bank-transfer__row">
            <span>转账金额</span><strong class="bank-transfer__amount">￥ {{ total.toLocaleString() }}</strong>
          </div>
          <div class="bank-transfer__row">
            <span>收款公司名称</span><span>{{ paymentInfo.company }}</span>
          </div>
          <div class="bank-transfer__row">
            <span>收款账号</span><span class="bank-transfer__acct">{{ paymentInfo.account }}</span>
          </div>
          <div class="bank-transfer__row">
            <span>收款开户行</span><span>{{ paymentInfo.bank }}</span>
          </div>
        </div>
      </div>
      <ElButton class="bank-transfer__copy" @click="copyBill">复制账单信息</ElButton>
      <ElButton class="bank-transfer__upload" type="primary" @click="openPayProofModal">上传支付凭证</ElButton>
    </div>
  </ElDialog>
  <ElDialog v-model="showSelect" class="address-select-dialog" width="760px" append-to-body>
    <template #header>
      <div class="address-select-dialog__header">
        <div class="address-select-dialog__title">选择收货地址</div>
      </div>
    </template>

    <div class="address-list">
      <div v-for="a in addresses" :key="a.id" class="address-card">
        <div class="address-card__header">
          <div class="address-card__header-left">
            <span class="address-card__name">{{ a.name }}</span>
          </div>
        </div>
        <div class="address-card__body">
          <div class="address-card__grid">
            <div class="address-card__label">收货人</div>
            <div class="address-card__value">{{ a.name }}</div>
            <div class="address-card__label">所在地区</div>
            <div class="address-card__value">{{ a.region }}</div>
            <div class="address-card__label">地址</div>
            <div class="address-card__value">{{ a.detail }}</div>
            <div class="address-card__label">联系方式</div>
            <div class="address-card__value">{{ a.phone }}</div>
          </div>
          <a class="address-card__choose-link" href="javascript:void(0)" @click="chooseAddr(a)">选择此地址</a>
        </div>
      </div>
    </div>
  </ElDialog>
  <AddressModal v-model="showAdd" :initial="current" @success="reloadAddresses" />
  <ElDialog v-model="showResult" class="payment-result-dialog" width="520px" append-to-body :show-close="false">
    <template #header>
      <div class="payment-result__header">
        <div class="payment-result__title">
          {{ resultType === 'success' ? '付款完成' : '支付失败' }}
        </div>
      </div>
    </template>
    <div class="payment-result__body">
      <i :class="[
        'iconfont',
        resultType === 'success' ? 'icon-shouhou' : 'icon-zhifushibai',
        'payment-result__icon',
      ]"></i>
      <p class="payment-result__desc" v-if="resultType === 'success'">
        恭喜您🎉，您所购买的产品已经在来到您身边的路上啦～
      </p>
      <p class="payment-result__desc" v-else>
        很抱歉，您的付款失败了，请选择其他付款方式
      </p>
      <ElButton class="payment-result__btn" @click="handleResultAction">
        {{ resultType === 'success' ? '返回我的订单' : '返回购物车' }}
      </ElButton>
    </div>
  </ElDialog>
  <!-- 上传支付凭证弹窗 -->
  <PayProofUploadModal v-model="showPayProofModal" @success="handlePayProofSuccess" @cancel="handlePayProofCancel" />
</template>

<script setup lang="ts">
import { ref, watch, computed, onUnmounted } from "vue";
import { Close } from "@element-plus/icons-vue";
import AddressModal from "~/components/address/AddressModal.vue";
import PayProofUploadModal from "~/components/PayProofUploadModal.vue";
import { useRouter } from "#imports";
import { ElMessage } from "element-plus";
import QRCode from "qrcode";
const { currencyType } = useCurrency();
const props = withDefaults(
  defineProps<{
    modelValue?: boolean;
    total: number;
    address?: { full: string; name: string; phone: string };
    addressList?: any[];
    orderId?: number;
    orderNumber?: string;
    supportDeposit?: number;
    createTime?: string;
  }>(),
  { total: 0, modelValue: false }
);
const emit = defineEmits<{
  (e: "update:modelValue", v: boolean): void;
  (e: "update:address", v: { full: string; name: string; phone: string }): void;
}>();
const open = ref<boolean>(props.modelValue || false);
watch(
  () => props.modelValue,
  (v) => {
    if (v !== undefined) open.value = !!v;
  }
);
watch(open, (v) => emit("update:modelValue", v));
const method = ref<"alipay" | "wechat" | "bank">("alipay");
const qr = ref<string>("");
const countdown = ref<string>("");
const countdownTimer = ref<any>(null);
const payNumber = ref<string>("");
const paymentInfo = ref({
  company: "",
  account: "",
  bank: ""
});
const copyBill = async () => {
  const text = `转账金额: ￥${props.total}\n收款公司名称: ${paymentInfo.value.company}\n收款账号: ${paymentInfo.value.account}\n收款开户行: ${paymentInfo.value.bank}`;
  try {
    await navigator.clipboard.writeText(text);
  } catch { }
};

const fetchPaymentConfig = async () => {
  try {
    const infoRes = await api.get<any>("/user/queryConfig", {}, { server: false, key: `payment-config-${Date.now()}`, retry: 0 });
    const raw = (infoRes as any)?.data || (infoRes as any)?.raw || [];
    const list: Array<{ paramKey?: string; paramValue?: string }> = Array.isArray(raw) ? raw : [];
    const getVal = (k: string) => String(list.find((x) => String(x.paramKey) === k)?.paramValue ?? "");

    paymentInfo.value = {
      company: getVal("payment_company"),
      account: getVal("payment_account"),
      bank: getVal("payment_bank")
    };
  } catch {
    // 使用默认值
  }
};

type FullAddr = {
  id: number;
  name: string;
  phone: string;
  region: string;
  detail: string;
  isDefault: boolean;
};
const showSelect = ref(false);
const addresses = ref<FullAddr[]>([]);
const mapAddress = (item: any): FullAddr => {
  return {
    id: Number(item?.addrId ?? item?.id ?? 0),
    name: String(item?.receiver ?? item?.name ?? ""),
    phone: String(item?.mobile ?? item?.tel ?? item?.phone ?? ""),
    region:
      [item?.province, item?.city, item?.area].filter(Boolean).join(" ") ||
      String(item?.region ?? ""),
    detail: String(
      item?.addr ?? item?.addrDetail ?? item?.detail ?? item?.address ?? ""
    ),
    isDefault:
      item?.commonAddr == 1 ||
      item?.isDefault === true ||
      item?.defaultFlag === 1,
  };
};
watch(
  () => props.addressList,
  (list) => {
    const arr = Array.isArray(list) ? list : [];
    addresses.value = arr.map(mapAddress);
  },
  { immediate: true }
);
const selected = ref<{ full: string; name: string; phone: string } | null>(
  null
);
const curAddr = computed(
  () => selected.value ?? props.address ?? { full: "", name: "", phone: "" }
);
const hasAddr = computed(() => !!curAddr.value.full);
const api = useApi();
// 在购物车下单流程中，首次创建订单后保存的订单ID和订单号
const createdOrderId = ref<number | undefined>(undefined);
const createdOrderNumber = ref<string | undefined>(undefined);

const chooseAddr = async (a: FullAddr) => {
  const v = {
    full: `${a.region} ${a.detail}`.trim(),
    name: a.name,
    phone: a.phone,
  };
  try {
    const oid = props.orderId || createdOrderId.value;
    if (oid && a.id) {
      const payload = { orderId: oid, addrId: a.id };
      const r = await api.post("/p/order/updateAddress", payload);
      if (!r.ok) {
        ElMessage.error(r.msg || "更新收货地址失败");
        return;
      }
    }
    const onum = props.orderNumber || createdOrderNumber.value;
    if (onum) {
      const d = await api.get<any>("/p/myOrder/orderDetail", {
        orderNumber: onum,
      });
      const data = d.data || d.raw || {};
      const addr = data.userAddrDto || data;
      const refreshed = {
        full:
          [addr.province, addr.city, addr.area, addr.addr, addr.addrDetail, addr.address, addr.detail]
            .filter(Boolean)
            .join(" ")
            .trim() || v.full,
        name: addr.receiver || addr.addrUser || v.name,
        phone: addr.mobile || addr.phone || v.phone,
      };
      selected.value = refreshed;
      emit("update:address", refreshed);
    } else {
      selected.value = v;
      emit("update:address", v);
    }
    showSelect.value = false;
  } catch {
    ElMessage.error("网络异常，更新收货地址失败");
  }
};

const showAdd = ref(false);
const current = ref<FullAddr | undefined>(undefined);
const openAdd = () => {
  current.value = undefined;
  showAdd.value = true;
};
const reloadAddresses = async () => {
  try {
    const r = await api.get<any>(
      "/p/address/list",
      {},
      { server: false, key: "address-list-modal", retry: 0 }
    );
    const list = (r as any)?.data ?? (r as any)?.raw ?? [];
    const arr = Array.isArray(list) ? list : [];
    addresses.value = arr.map(mapAddress);

    // 如果没有传入orderId/orderNumber，说明是购物车下单流程
    // 此时添加地址后，需要调用submit接口提交订单
    if (!props.orderId && !props.orderNumber) {
      const target =
        addresses.value.find((a) => a.isDefault) || addresses.value[0];
      if (target) {
        const payload = {
          orderShopParam: [{ shopId: 1 }],
          addrId: target.id,
          supportDeposit: props.supportDeposit ?? 0,
        };
        const subRes = await api.post<any>("/p/order/submit", payload, {
          server: false,
          key: `order-submit-retry-${Date.now()}`,
          retry: 0,
        });
        if (subRes.code === "00000") {
          const sData = (subRes as any)?.data ?? (subRes as any)?.raw ?? {};
          createdOrderId.value = sData?.orderId;
          // 有些接口返回orderNumbers（逗号分隔），有些返回orderNumber
          // 这里假设可能返回单个orderNumber或orderNumbers
          // 如果是购物车合并下单，可能有多个，但这里我们只取一个用于展示详情？
          // 通常详情接口只支持单个orderNumber
          // 如果是多个订单，这里可能处理不了详情刷新，但updateAddress可能只需要orderId
          // 暂时尝试获取 orderNumber
          createdOrderNumber.value = sData?.orderNumber ?? sData?.orderNumbers?.split(",")?.[0];

          showAdd.value = false;
          // 更新选中的地址显示
          const v = {
            full: `${target.region} ${target.detail}`.trim(),
            name: target.name,
            phone: target.phone,
          };
          selected.value = v;
          emit("update:address", v);
        } else {
          ElMessage.error(subRes.msg || "提交订单失败");
        }
      } else {
        showAdd.value = false;
      }
    } else {
      showAdd.value = false;
    }
  } catch {
    ElMessage.error("网络异常，请重试");
  }
};
watch(showSelect, (v) => {
  if (v && !addresses.value.length) reloadAddresses();
});

// 支付结果弹窗
const showResult = ref(false);
const resultType = ref<"success" | "fail">("success");
const router = useRouter();
const openResult = (type: "success" | "fail") => {
  resultType.value = type;
  showResult.value = true;
};
const handleResultAction = () => {
  showResult.value = false;
  open.value = false;
  router.push(resultType.value === "success" ? "/user/orders" : "/cart");
};
const toggleMethod = (t: "alipay" | "wechat" | "bank") => {
  if (!hasAddr.value) {
    ElMessage.warning("请先添加收货地址方可继续付款");
    return;
  }
  method.value = t;
};
const loadPayQRCode = async () => {
  try {
    if (!hasAddr.value) return;
    qr.value = "";
    const onum = props.orderNumber || createdOrderNumber.value;
    if (!onum) return;
    const payType = method.value === "wechat" ? 1 : 2;
    const payload: any = { orderNumber: onum, payType, source: 1 };
    payload.supportDeposit = props.supportDeposit ?? 0;
    const r = await api.post<any>("/p/order/pay", payload, {
      server: false,
      key: `order-pay-${onum}-${payType}-${Date.now()}`,
      retry: 0,
    });
    const ok = (r as any)?.code === "00000" || (r as any)?.ok === true;
    if (!ok) {
      ElMessage.error((r as any)?.msg || "生成支付二维码失败");
      return;
    }
    const d = (r as any)?.data ?? (r as any)?.raw ?? {};
    payNumber.value = d?.payNumber || "";
    let url: string = "";
    if (typeof d === "string") {
      url = d;
    } else {
      const b64 = String(d?.imgBase64 ?? d?.qrImage ?? "");
      url =
        d?.qrCodeUrl ??
        d?.qrCode ??
        d?.codeUrl ??
        d?.payUrl ??
        d?.url ??
        d?.qrcode ??
        d?.qr ??
        "";
      if (!url && b64) {
        url = b64.startsWith("data:") ? b64 : `data:image/png;base64,${b64}`;
      }
    }
    // If it's a URL (especially Alipay/WeChat), convert to QR code image locally
    if (
      url &&
      !/^data:image\//.test(url) &&
      (!/^(https?:)?\/\//.test(url) || url.includes("qr.alipay.com") || url.includes("weixin.qq.com"))
    ) {
      try {
        url = await QRCode.toDataURL(url, { width: 200, margin: 1 });
      } catch (e) {
        console.error("Generate QR Code error:", e);
      }
    }
    qr.value = url;
  } catch {
    ElMessage.error("网络异常，请稍后重试");
  }
};

const timer = ref<any>(null);
const stopPolling = () => {
  if (timer.value) {
    clearInterval(timer.value);
    timer.value = null;
  }
};
const startPolling = () => {
  stopPolling();
  if (!qr.value || !open.value) return;

  timer.value = setInterval(async () => {
    try {
      const onum = props.orderNumber || createdOrderNumber.value;
      if (!onum || !qr.value || !open.value) {
        stopPolling();
        return;
      }
      const payType = method.value === "wechat" ? 1 : 2;
      const payload: any = { orderNumber: onum, payType, source: 1 };
      payload.supportDeposit = props.supportDeposit ?? 0;
      if (payNumber.value) {
        payload.payNumber = payNumber.value;
      }

      const r = await api.post<any>("/p/order/payQuery", payload, {
        server: false,
        key: `pay-query-${Date.now()}`,
        retry: 0
      });

      // Assume success if code is 00000 or ok is true
      // Sometimes backend returns boolean true/false or specific string
      const ok = (r as any)?.code === "00000" && (r as any)?.data == 'TRADE_SUCCESS';

      if (ok) {
        stopPolling();
        openResult('success');
      }
    } catch (e) {
      // Ignore polling errors, just retry next tick
    }
  }, 3000);
};

const startCountdown = () => {
  stopCountdown();
  if (!props.createTime) return;

  const updateTime = () => {
    const createTime = new Date(props.createTime).getTime();
    const now = Date.now();
    const deadline = createTime + 30 * 60 * 1000;
    const remaining = deadline - now;

    if (remaining <= 0) {
      countdown.value = "00:00:00";
      stopCountdown();
      return;
    }

    const hours = Math.floor(remaining / (1000 * 60 * 60));
    const minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((remaining % (1000 * 60)) / 1000);

    countdown.value = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  };

  updateTime();
  countdownTimer.value = setInterval(updateTime, 1000);
};

const stopCountdown = () => {
  if (countdownTimer.value) {
    clearInterval(countdownTimer.value);
    countdownTimer.value = null;
  }
};

watch(qr, (v) => {
  if (v && method.value !== 'bank') startPolling();
  else stopPolling();
});

watch(open, (v) => {
  if (!v) {
    stopPolling();
    stopCountdown();
  } else {
    if (qr.value && method.value !== 'bank') startPolling();
    if (method.value === 'bank' && props.createTime) startCountdown();
  }
});

onUnmounted(() => {
  stopPolling();
  stopCountdown();
});

// 合并所有触发支付二维码加载的监听
watch(
  [open, method, () => props.orderNumber, createdOrderNumber, hasAddr],
  ([o, m, onum, conum, addr]) => {
    if (o && addr && m !== "bank" && (onum || conum)) {
      loadPayQRCode();
    }
  },
  { immediate: true }
);

watch(
  [method, () => props.createTime],
  ([m, ct]) => {
    if (open.value && m === 'bank' && ct) {
      stopPolling();
      startCountdown();
      fetchPaymentConfig();
    } else {
      stopCountdown();
      if (open.value && qr.value && m !== 'bank') {
        startPolling();
      }
    }
  }
);

// 上传支付凭证相关
const showPayProofModal = ref(false);

const openPayProofModal = () => {
  showPayProofModal.value = true;
};

const handlePayProofSuccess = async (url: string, callback: (success: boolean) => void) => {
  const orderNo = props.orderNumber || createdOrderNumber.value;
  if (!orderNo) {
    ElMessage.warning("订单号不存在");
    callback(false);
    return;
  }

  try {
    const res = await api.post<any>("/p/myOrder/uploadImg", {
      orderNumber: orderNo,
      voucherImg: url,
    });
    const ok = (res as any)?.code === "00000" || (res as any)?.ok === true;
    if (!ok) {
      ElMessage.error((res as any)?.msg || "上传支付凭证失败");
      callback(false);
      return;
    }
    ElMessage.success("支付凭证上传成功");
    callback(true);
    router.push("/user/orders");
  } catch {
    ElMessage.error("网络异常，请稍后重试");
    callback(false);
  }
};

const handlePayProofCancel = () => {
  console.log("取消上传支付凭证");
};

defineExpose({ openResult });
</script>

<style scoped>
.checkout-dialog__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.checkout-dialog__title {
  font-size: 0.2rem;
  color: #121212;
  font-weight: 600;
}

.checkout-dialog__close {
  cursor: pointer;
  width: 0.4rem;
  height: 0.4rem;
}

.payment-options {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.24rem;
}

.payment-option {
  display: flex;
  align-items: center;
  gap: 0.2rem;
  border: 1px solid #e5e5e5;
  padding: 0.18rem;
  cursor: pointer;
}

.payment-option--active {
  border: 2px solid #222;
}

.payment-option--disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.payment-option__radio {
  width: 0.18rem;
  height: 0.18rem;
  border: 1px solid #d9d9d9;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.payment-option--active .payment-option__radio {
  border-color: #222;
  border-width: 2px;
}

.payment-option .iconfont {
  font-size: 0.32rem;
}

.icon-zhifubao {
  color: #1677ff;
}

.icon-weixinzhifu {
  color: #1aae1a;
}

.icon-yinhangkazhifu {
  color: #222;
}

.payment-option__main strong {
  display: block;
}

.payment-option__main span {
  color: #666;
  font-size: 0.14rem;
}

.address-section {
  margin: 0.7rem 0 0.9rem;
}

.address-section__title {
  font-size: 0.2rem;
  color: #121212;
  margin-bottom: 0.2rem;
  display: flex;
  align-items: center;
  gap: 0.12rem;
}

.address-section-noaddr {
  margin: 0.7rem 0 0.9rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}

.address-section-noaddr .address-section__title {
  margin-bottom: 0;
}

.address-section__row {
  display: grid;
  grid-template-columns: 1fr auto auto;
  align-items: center;
  gap: 0.16rem;

}

.address-section__info {
  display: flex;
  gap: 0.12rem;
}

.address-section__full {}

.address-section__meta {
  color: #666;
}

.address-section__actions {
  display: inline-flex;
  gap: 0.1rem;
  align-items: center;
}

.address-section__edit {
  color: #333;
}

.address-section__empty {
  display: flex;
  align-items: center;
}

.address-section__add {
  font-size: 0.16rem;
  color: #121212;
  cursor: pointer;
  margin-left: 0.1rem;
}

.address-section__warn {
  position: absolute;
  max-width: 6rem;
  top: 0.4rem;
  left: 0;
  font-size: 0.16rem;
}

.address-list {
  display: grid;
  gap: 0.16rem;
}

.address-card {
  border: 1px solid #eee;
  background: #fff;
}

.address-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.14rem 0.18rem;
  border-bottom: 1px solid #eee;
}

.address-card__header-left {
  display: flex;
  align-items: center;
  gap: 0.12rem;
}

.address-card__name {
  font-weight: 600;
}

.address-card__body {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 0.16rem;
  padding: 0.18rem;
}

.address-card__grid {
  display: grid;
  grid-template-columns: 0.8fr 2.2fr;
  row-gap: 0.12rem;
  column-gap: 0.2rem;
}

.address-card__label {
  color: #666;
}

.address-card__value {
  color: #333;
}

.address-card__choose-link {
  align-self: center;
  color: #409eff;
  cursor: pointer;
}

.address-select-dialog__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.address-select-dialog__title {
  font-size: 0.24rem;
  font-weight: 600;
  color: #121212;
}

.payment-content {
  text-align: center;
  margin-bottom: 0.2rem;
}

.payment-content__price {
  color: #e74c3c;
  font-size: 0.32rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.1rem;
}

.payment-content__discount {
  color: #999;
  margin: 0.08rem 0 0.2rem;
}

.payment-content__qrcode {
  width: 2.2rem;
  height: 2.2rem;
  border: 1px solid #ddd;
  margin: 0.2rem auto;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.payment-content__placeholder {
  width: 2.4rem;
  height: 2.4rem;
  margin: 0.2rem auto;
  border: 1px solid #C9CBCD;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #121212;
  font-size: 0.16rem;
}

.payment-content__agreements {
  color: #666;
  text-align: center;
}

.bank-transfer {
  padding: 0 2.6rem;
}

.bank-transfer__card {
  border: 1px solid #eee;
  padding: 0.22rem;
  margin-bottom: 0.2rem;
}

.bank-transfer__ok {
  text-align: center;
  font-weight: 600;
  margin-bottom: 0.12rem;
}

.bank-transfer__warn {
  background: #ffe9e9;
  color: #c0392b;
  padding: 0.14rem;
  margin: 0.12rem auto 0.18rem;
  max-width: 6rem;
}

.bank-transfer__bill {
  border-top: 1px solid #eee;
  padding-top: 0.16rem;
  margin-top: 0.14rem;
}

.bank-transfer__row {
  display: flex;
  justify-content: space-between;
  padding: 0.08rem 0;
}

.bank-transfer__row span:first-child {
  color: #666;
  min-width: 2rem;
}

.bank-transfer__amount {
  color: #e74c3c;
  font-size: 0.22rem;
  font-weight: 700;
}

.bank-transfer__acct {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas,
    "Liberation Mono", "Courier New", monospace;
  letter-spacing: 0.02rem;
}

.bank-transfer__copy {
  width: 100%;
  background: #000;
  color: #fff;
  height: 0.56rem;
  margin-bottom: 0.12rem;
}

.bank-transfer__upload {
  width: 100%;
  background: #121212;
  border-color: #121212;
  color: #fff;
  height: 0.56rem;
  margin-left: 0;
}

.bank-transfer__upload:hover {
  background: #333;
  border-color: #333;
}

.payment-result__header {
  display: flex;
  justify-content: center;
  align-items: center;
}

.payment-result__title {
  font-size: 0.2rem;
  color: #121212;
  font-weight: 600;
}

.payment-result__body {
  text-align: center;
  padding-bottom: 0.1rem;
}

.payment-result__icon {
  font-size: 0.6rem;
  display: inline-block;
  margin: 0.2rem 0 0.24rem;
  color: #121212;
}

.payment-result__desc {
  color: #333;
  margin: 0.1rem auto 0.24rem;
  max-width: 6.4rem;
}

.payment-result__btn {
  width: 2.2rem;
  height: 0.52rem;
  background: #000;
  color: #fff;
}

.tax {
  color: #666;
  font-size: 0.16rem;
  font-weight: 400;
}
</style>
